import React from 'react'

export const Chatbot = () => {
  return (
    <div>
      <df-messenger
  project-id="afterschool125"
  agent-id="c0cc7ee8-1550-4d25-a88d-b140e33f4340"
  language-code="en"
  max-query-length="-1">
  <df-messenger-chat
   chat-title="AfterSchool ">
  </df-messenger-chat>
</df-messenger>
    </div>
  )
}
